import React from 'react';
import { Props } from 'component/common/ActivityCard/ActivityCard.selectors';
import { Box, Rating, Typography } from '@drone-js/core';
import { StringFormatter } from '@agoda/react-handyman';
import { useSelector } from 'react-redux';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';
import BookingCounter from 'component/common/BookingCounter/BookingCounter';
import { FeatureName } from 'core/constant/FeatureName';
import Feature from 'component/common/Experiment/Feature';
import { getBookingCountForBadge } from 'core/utils/badgeUtil';

interface ActivityCardStarRatingProps {
    isMobileScreen: boolean;
}

const ActivityCardStarRating: React.FC<ActivityCardStarRatingProps & Pick<Props, 'activity'>> = ({ activity, isMobileScreen }) => {
    const cms = useSelector(selectCmsFromBootstrap);
    const showRating = activity.rating > 0;
    const bookingInfoBadges = activity.badges?.bookingInfo || [];
    const bookingCount = getBookingCountForBadge(bookingInfoBadges);
    const showSeparator = showRating && bookingCount;

    return (
        <Box display="flex" flexDirection="row" flexWrap="wrap" alignItems="baseline">
            <Box
                key="starRatingBox"
                display="flex"
                flexDirection="row"
                alignItems="baseline"
                data-testid="activities-card-star-rating"
                my={isMobileScreen ? '8' : '0'}
                mt={isMobileScreen ? '0' : '8'}
            >
                {showRating && (
                    <>
                        <Rating label={cms[146543]} score={1} size="m" variant="star" color="hotel" />
                        <Typography key="averageScore" variant="body-s-strong" ms="4">
                            {activity.averageScore}
                        </Typography>
                        <Feature.Off name={FeatureName.BadgesV2ActivityCard}>
                            <Typography data-testid="review-count-text" key="totalCount" variant="caption-default" textColor="base.subtle" ms="8" display="inline">
                                {StringFormatter.format(cms[269275], activity.totalCount.toLocaleString())}
                            </Typography>
                        </Feature.Off>
                        <Feature.On name={FeatureName.BadgesV2ActivityCard}>
                            <Typography data-testid="review-count-text" key="totalCount" variant="caption-default" textColor="base.subtle" ms="8" display="inline">
                                {StringFormatter.format('({0})', activity.totalCount.toLocaleString())}
                            </Typography>
                        </Feature.On>
                    </>
                )}
            </Box>
            {showSeparator && (
                <Typography display="inline-flex" variant="caption-default" mx="4" textColor="base.subtle">
                    {StringFormatter.format('•')}
                </Typography>
            )}
            <Feature.On name={FeatureName.BadgesV2ActivityCard}>
                <Box data-testid="activity-bookingInfo-badges-container">
                    <BookingCounter showSeparator={false} badges={bookingInfoBadges} />
                </Box>
            </Feature.On>
        </Box>
    );
};

ActivityCardStarRating.displayName = 'ActivityCardStarRating';
export default ActivityCardStarRating;
